import React from 'react';
import { Paper, Typography, Box, Divider, List, ListItem, Button } from '@mui/material';

export default function PaymentReceipt({ paymentData, onClose }) {
  if (!paymentData) return null;

  const id = paymentData.id || paymentData.orderId || '';
  const status = paymentData.status || '';
  const purchaseUnit = paymentData.purchase_units?.[0] || {};
  const capture = purchaseUnit?.payments?.captures?.[0] || {};
  const amount = capture?.amount || purchaseUnit?.amount || {};

  return (
    <Paper elevation={3} sx={{ p: 2 }}>
      <Typography variant="h5" gutterBottom>Receipt</Typography>
      <Typography variant="subtitle1">Order ID: {id}</Typography>
      <Typography variant="subtitle1">Status: {status}</Typography>

      {capture && capture.update_time && (
        <Typography variant="body2">Captured: {new Date(capture.update_time).toLocaleString()}</Typography>
      )}

      <Box sx={{ my: 1 }}>
        <Typography variant="body1">Amount: {amount?.value || ''} {amount?.currency_code || ''}</Typography>
        {capture?.id && <Typography variant="body2">Transaction ID: {capture.id}</Typography>}
      </Box>

      <Divider sx={{ my: 1 }} />

      {paymentData.payer && (
        <>
          <Typography variant="h6">Payer</Typography>
          <List dense>
            <ListItem>
              <Typography>Name: {paymentData.payer.name?.given_name} {paymentData.payer.name?.surname}</Typography>
            </ListItem>
            <ListItem>
              <Typography>Email: {paymentData.payer.email_address}</Typography>
            </ListItem>
          </List>
        </>
      )}

      {/* <Box sx={{ display: 'flex', gap: 1, mt: 2 }}>
        <Button variant="outlined" onClick={onClose}>Close</Button>
        <Button variant="contained" onClick={() => { navigator.clipboard?.writeText(JSON.stringify(paymentData)); }}>Copy JSON</Button>
      </Box> */}
    </Paper>
  );
}
